import type { FlightControls } from "@frontier/content/combat-rules";

const codes = [
  "Digit1",
  "Digit2",
  "Digit3",
  "Digit4",
  "Digit5",
  "Digit6",
  "Digit7",
  "Digit8",
  "Digit9",
  "Digit0",
  "Minus",
];
const labels = ["Q", "2", "3", "4", "5", "6", "7", "8", "9", "0", "−"];

export function abilityShortcutIndex(code: string): number | null {
  if (code === "KeyQ") return 0;
  const index = codes.indexOf(code);
  return index < 0 ? null : index;
}

export function abilityHotkey(index: number): string {
  return labels[index] ?? "";
}

export function abilityPhysicalSlot(
  controls: FlightControls | undefined,
  index: number,
): number | null {
  if (!controls || !Number.isInteger(index) || index < 0) return null;
  if (controls.format === 3 || controls.format === 4)
    return controls.abilities[index]?.slot ?? null;
  if (index < 2) return index;
  return index === 2 && controls.format === 2 && controls.thirdModuleId
    ? 2
    : null;
}
